<template>
	<div class="product-resource">
		<el-card class="header-tool" shadow="hover" style="min-width:1200px ;">
			<el-row :gutter="10">
				<el-col :span="18">
					<el-input placeholder="请输入资源名称关键字(模糊检索)" v-model="searchName" class="input-with-select">
						<el-select placeholder="请选择" filterable slot="prepend" v-model="productID" @change="resourceTypeID='';page_current=1;">
							<el-option label="全部产品" value="">
							</el-option>
							<el-option v-for="item in productList" :label="item.name" :value="item.id">
							</el-option>
						</el-select>
						<el-select placeholder="请选择" slot="prepend" v-model="resourceTypeID" @change="page_current=1;">
							<el-option label="全部分类" value="">
							</el-option>
							<el-option v-for="item in getResourceTypeList(productID)" :label="item.name"
								:value="item.id">
							</el-option>
						</el-select>
					</el-input>
				</el-col>
			</el-row>
		</el-card>

		<el-card shadow="hover" style="margin-top: 10px;">
			<div slot="header" class="clearfix">
				<span>产品资源列表({{tableDataCount}})</span>
				<el-button style="float: right; padding: 3px 0" type="text" @click="addResource()">新增产品资源
				</el-button>
			</div>
			<el-table :data="showDate()"  style="width: 100%;margin-bottom: 20px;">
				<el-table-column type="expand">
					<template slot-scope="props">
						<!-- 1+x 资源 -->
						<div v-if="props.row.fileType=='json'">
							<el-form label-position="left" class="demo-table-expand">
								<el-form-item label="资源名称">
									<span>{{ props.row.name }}</span>
								</el-form-item>
								<el-form-item label="任务描述">
									<span>{{ JSON.parse(props.row.introduce).renWuMiaoShu }}</span>
								</el-form-item>
								<el-form-item label="知识目标">
									<span>{{ JSON.parse(props.row.introduce).zhiShiMuBiao }}</span>
								</el-form-item>
								<el-form-item label="技能目标">
									<span>{{ JSON.parse(props.row.introduce).jiNengMuBiao }}</span>
								</el-form-item>
								<el-form-item label="素养目标">
									<span>{{ JSON.parse(props.row.introduce).suYangMuBiao }}</span>
								</el-form-item>
								<el-form-item label="任务目标">
									<span>{{ JSON.parse(props.row.introduce).renWuMuBiao }}</span>
								</el-form-item>
								<el-form-item label="任务分析">
									<span>{{ JSON.parse(props.row.introduce).renWuFenXi }}</span>
								</el-form-item>
								<el-form-item label="实施流程" v-if="JSON.parse(props.row.introduce).shiShiLiuCheng">
									<iframe :src="$config.fileurl+JSON.parse(props.row.introduce).shiShiLiuCheng"
										style="width: 100%;height: 500px;"></iframe>
								</el-form-item>
								<el-form-item label="课件资源">
									<!-- <span>{{ JSON.parse(props.row.introduce).fileList }}</span> -->
									<div>
										<div v-for="item in JSON.parse(props.row.introduce).fileList">
											<div
												v-if="item.filrurl.indexOf('.jpg')>-1||item.filrurl.indexOf('.png')>-1">
												<img :src="$config.fileurl+item.filrurl" />
											</div>
											<div v-if="item.filrurl.indexOf('.mp4')>-1">
												<video :src="$config.fileurl+item.filrurl" controls="controls"
													width="100%"></video>
											</div>
											<div v-if="item.filrurl.indexOf('.pdf')>-1">
												<iframe :src="$config.fileurl+item.filrurl"
													style="width: 100%;height: 500px;"></iframe>
											</div>
											<span>{{item.name}}</span>
										</div>
									</div>
								</el-form-item>
							</el-form>
						</div>
						<!-- 图片类 -->
						<div v-else-if="props.row.fileType=='image/png'||props.row.fileType=='image/jpeg'"
							style="text-align: center;">
							<el-image :src="$config.fileurl+props.row.fileAddress" style="border: 1px solid #000;width: 100%;"></el-image>
						</div>
						<!-- 视频 -->
						<div v-else-if="props.row.fileType=='video/mp4'">
							<video :src="$config.fileurl+props.row.fileAddress" controls="controls"
								width="100%"></video>
						</div>
						<!-- pdf文档 -->
						<div v-else-if="props.row.fileType=='application/pdf'">
							<iframe :src="$config.fileurl+props.row.fileAddress"
								style="width: 100%;height: 500px;"></iframe>
						</div>
						<!-- 思政-【视频-图片-连接 】类型资源-->
						<div v-else-if="props.row.fileType=='Video_Pic_Link'">
							<el-row>
								<el-col style="text-indent: 2rem;padding: 10px 0 20px 0;font-size: 16px;">
									{{props.row.introduce}}
								</el-col>
								<el-col v-if="JSON.parse(props.row.fileAddress).VideoPath">
									<video :src="$config.fileurl+JSON.parse(props.row.fileAddress).VideoPath"
										controls="controls" width="100%"></video>
								</el-col>
								<el-col v-if="JSON.parse(props.row.fileAddress).ImagePath">
									<div class="demo-image__lazy"
										v-for="url in JSON.parse(props.row.fileAddress).ImagePath">
										<p v-show="url.introduct">{{url.index+'.'+ url.introduct}}</p>
										<el-image :src="$config.fileurl+url.path" lazy></el-image>
									</div>
								</el-col>
								<el-col v-if="JSON.parse(props.row.fileAddress).Link">
									<el-button type="primary" size="mini"
										@click="newOpenPage(JSON.parse(props.row.fileAddress).Link)">链接</el-button>
								</el-col>
							</el-row>
						</div>
						<div v-else-if="props.row.fileType=='webUrl'">
							<el-button type="primary" size="mini" @click="newOpenPage(props.row.fileAddress)">链接
							</el-button>
						</div>
					</template>
				</el-table-column>
				<el-table-column type="index" width="50">
				</el-table-column>
				<el-table-column prop="categoryID" label="缩略图" width="100">
					<template slot-scope="scope">
						<el-image :src="$http.fileUrl+scope.row.fileImg" style="height: 60px;"></el-image>
					</template>
				</el-table-column>
				<el-table-column prop="name" label="资源名称">
					<template slot-scope="scope">
						<div v-html="scope.row.name.replace(searchName,'<font  color=\'red\'>'+searchName+'</font>')">
						</div>
					</template>
				</el-table-column>
				<el-table-column label="所属产品">
					<template slot-scope="scope">
						{{getProductName(scope.row.productID)}}
					</template>
				</el-table-column>
				<el-table-column label="所属分类" width='180'>
					<template slot-scope="scope">
						{{getResourceTypeName(scope.row.resourceTypeID)}}
					</template>
				</el-table-column>
				
				<el-table-column prop="fileType" label="文件类型" width='120'>
				</el-table-column>
				<el-table-column prop="extension" label="后缀名" width='80'>
				</el-table-column>
				<el-table-column prop="fileSize" label="文件大小" width='120'>
					<template slot-scope="scope">
						{{renderSize(scope.row.fileSize)}}
					</template>
				</el-table-column>
				<el-table-column prop="createTime" label="创建时间" width="160">
				</el-table-column>
				<el-table-column label="操作" width="200">
					<template slot-scope="scope">
						<el-button size="mini" icon="el-icon-edit" @click="edit(scope.row)"
							v-if="scope.row.productID!='f85fc1b0-447f-78ec-e775-a207c4d78b33'">编辑</el-button>&nbsp;
						<el-popconfirm title="确定要删除吗" @confirm="del(scope.row.id)">
							<el-button size="mini" type="danger" icon="el-icon-delete" slot="reference">
								删除</el-button>
						</el-popconfirm>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination background layout="total, sizes, prev, pager, next, jumper" :total="tableDataCount"
				class="pagination" @size-change="sizeChange" @current-change="currentChange">
			</el-pagination>
		</el-card>
		<!-- 添加 -->
		<editResource type='添加' :dialogVisible='AddVisible' :productList='productList'
			:resourceTypeList='resourceTypeList' @before-close="AddVisible=false;loadData()" v-if="AddVisible">
		</editResource>
		<editResource1 dialogType='添加' :outerVisible='addVisible_1_X' :productList='productList'
			:resourceTypeList='resourceTypeList' @before-close="addVisible_1_X=false;loadData()" v-if="addVisible_1_X">
		</editResource1>
		<!-- 编辑 -->
		<editResource type='编辑' :dialogVisible='EditVisible' :productList='productList'
			:resourceTypeList='resourceTypeList' @before-close="EditVisible=false;loadData()" :obj='dialogModels'>
		</editResource>
		<editResource1 dialogType='编辑' :outerVisible='EdotVisible_1_X' :productList='productList'
			:resourceTypeList='resourceTypeList' @before-close="EdotVisible_1_X=false;loadData()" :obj='dialogModels'>
		</editResource1>
	</div>
</template>

<script>
	import editResource from './components/editResource.vue'
	import editResource1 from './components/editResource_1_x.vue'

	import {
		mapGetters
	} from 'vuex'
	export default {
		data() {
			return {
				//table +分页
				tableData: [],
				tableDataCount: 0,
				page_size: 10,
				page_current: 1,
				//弹出框-编辑 添加				
				AddVisible: false,
				addVisible_1_X: false,
				EditVisible: false,
				EdotVisible_1_X: false,
				dialogModels: {},
				dialogType: 'Add',
				imageUrl: '',
				//筛选条件
				productList: [],
				productID: '',
				resourceTypeList: [],
				resourceTypeID: '',
				searchName: ''
			}
		},
		components: {
			editResource,
			editResource1
		},
		computed: {
			...mapGetters(['getUserInfo'])
		},
		created() {
			this.init()
		},
		methods: {
			async init() {
				await this.$http.get('api/Product/GetProductList').then(res => {
					// 过滤 显示有场景名称产品
					this.productList = res.data.data.filter(item => item.sceneName)
				})

				await this.$http.get('api/productResource/GetResourceTypeList').then(res => {
					this.resourceTypeList = []
					res.data.data.map(item => {
						this.productList.map(item1 => {
							if (item1.id == item.productID) {
								this.resourceTypeList.push(item)
							}
						})
					})
				})
			},
			loadData() {
				this.$http.get('api/productResource/GetProduct_ResourceList').then(res => {
					this.tableData = res.data.data
				})
			},
			getResourceTypeList(val) {
				return this.resourceTypeList.filter(item => item.productID == val)
			},
			getProductName(val) {
				let product = this.productList.find(item => {
					return item.id == val
				})
				if (product) {
					return product.name
				}
				return ''
			},
			getResourceTypeName(val) {

				let type = this.resourceTypeList.find(item => {
					return item.id == val
				})
				if (type) {
					return type.name
				}
				return ''
			},
			showDate() {
				if (this.tableData) {
					let _tab = this.tableData.filter(item => item.name && item.name.search(this.searchName) > -1 && item
						.productID.search(this.productID) > -1 && item.resourceTypeID.search(this.resourceTypeID) > -1)
					this.tableDataCount = _tab.length
					return _tab.slice((this.page_current - 1) * this.page_size, this.page_current * this.page_size)
				}
			},
			sizeChange(e) {
				this.page_size = e
			},
			currentChange(e) {
				this.page_current = e
			},
			del(val) {
				this.$http.get('api/productResource/DelProduct_Resource/' + val).then(res => {
					if (res.data.code == '1') {
						this.$message({
							message: "删除成功",
							type: 'success'
						})
						this.loadData()
					}
				})
			},
			edit(val) {
				this.dialogModels = JSON.parse(JSON.stringify(val))
				if (val.productID == '8e451222-bdb9-905f-7f07-0b2e4e5bb1a5') {
					this.EdotVisible_1_X = true;
				} else {
					this.EditVisible = true
				}
			},
			renderSize(value) {
				if (null == value || value == '') {
					return "0 Bytes";
				}
				var unitArr = new Array("Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB");
				var index = 0;
				var srcsize = parseFloat(value);
				index = Math.floor(Math.log(srcsize) / Math.log(1024));
				var size = srcsize / Math.pow(1024, index);
				size = size.toFixed(2); //保留的小数位数
				return size + unitArr[index];
			},
			// 打开新页面-连接资源
			newOpenPage(val) {
				window.open(val)
			},
			//格式化图片集合
			getImgList(val) {
				console.log(val)
			},
			addResource() {
				if (this.productID) {
					if (this.productID == '8e451222-bdb9-905f-7f07-0b2e4e5bb1a5') {
						this.addVisible_1_X = true;
					} else {
						this.AddVisible = true;
					}
				} else {
					this.$message({
						message: "请选择产品",
						type: 'info'
					})
				}
			}
		},
		mounted() {
			this.loadData()
		}
	}
</script>

<style lang="scss">
	.product-resource{
		.header-tool{
			.el-select .el-input {
				width: 230px;
			}
			
			.input-with-select .el-input-group__prepend {
				background-color: #fff;
			}
		}
		
		
		
		
		.item {
			margin-top: 10px;
			margin-right: 40px;
		}
		
		
		.demo-table-expand {
			font-size: 0;
		}
		
		.demo-table-expand label {
			width: 90px;
			color: #99a9bf;
		}
		
		.demo-table-expand .el-form-item {
			margin-right: 0;
			margin-bottom: 0;
			width: 100%;
		}
		
		
		// 图片上传
		.avatar-uploader .el-upload {
			border: 1px dashed #d9d9d9;
			border-radius: 6px;
			cursor: pointer;
			position: relative;
			overflow: hidden;
		}
		
		.avatar-uploader .el-upload:hover {
			border-color: #409EFF;
		}
		
		.avatar-uploader-icon {
			font-size: 28px;
			color: #8c939d;
			width: 178px;
			height: 178px;
			line-height: 178px;
			text-align: center;
		}
		
		.avatar {
			width: 178px;
			height: 178px;
			display: block;
		}
		
		.pagination {
			margin: 10px 0;
			text-align: center;
		}
	}
</style>
